import MDBox from "components/MDBox";
import UiSideModal from "components/base/UiSideModal";
import UiTypography from "components/base/UiTypography";
import { ProposalPlantProduct, ProposalProduct } from "generated/graphql";
import PlantProductTruckingPanel from "./PlantProductTruckingPanel";
import { draftColors } from "./draftDesignTokens";
import { useDraftContext } from "./DraftContext";

type TruckingConfigModalProps = {
  open: boolean;
  onClose: () => void;
  product: ProposalProduct;
};

export default function TruckingConfigModal({ open, onClose, product }: TruckingConfigModalProps) {
  const { isReadOnly } = useDraftContext();
  const plantProducts = (product.proposalPlantProducts ?? []) as ProposalPlantProduct[];

  return (
    <UiSideModal
      open={open}
      onClose={onClose}
      title="Trucking Configuration"
      width="780px"
      closeButtonClassName="tour-trucking-modal-close"
    >
      <MDBox
        component="fieldset"
        disabled={isReadOnly}
        border={0}
        m={0}
        minWidth={0}
        p="24px"
        display="flex"
        flexDirection="column"
        gap="24px"
      >
        {plantProducts.map((pp, index) => (
          <PlantProductTruckingPanel
            key={pp.id}
            plantProduct={pp}
            plantIndex={index}
            product={product}
          />
        ))}
        {plantProducts.length === 0 && (
          <UiTypography uiVariant="body" sx={{ color: draftColors.textSecondary }}>
            No plant products configured for this product.
          </UiTypography>
        )}
      </MDBox>
    </UiSideModal>
  );
}
